type EduAccessChange = { message: string; token?: string };
const listeners = new Set<(change: EduAccessChange) => void>();
export function notifyEduAccessChange(change: EduAccessChange) { listeners.forEach(listener => listener(change)); }
export function subscribeEduAccessChange(listener: (change: EduAccessChange) => void) {
    listeners.add(listener); return () => { listeners.delete(listener); };
}
